module.exports = __webpack_public_path__ + "static/thanks-a3845b397b3e96dfdb93b642a54cf88f.svg";